import "../css/consent.css";

const parseConsent = () => {
  const node = document.querySelector("#nanzora-consent-config");
  if (!node) return { cookie: "nanzora_consent", state: {}, decided: false };
  try {
    return JSON.parse(node.textContent);
  } catch {
    return { cookie: "nanzora_consent", state: {}, decided: false };
  }
};

const config = parseConsent();
const root = document.querySelector("[data-nanzora-consent]");
const prefs = document.querySelector("#nanzora-consent-prefs");

const writeCookie = (state) => {
  const maxAge = 60 * 60 * 24 * 180;
  document.cookie = `${config.cookie}=${encodeURIComponent(JSON.stringify(state))}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
};

const setWpConsent = (state) => {
  if (typeof window.wp_set_consent !== "function") return;
  ["functional", "preferences", "statistics", "marketing"].forEach(
    (category) => {
      const allowed =
        category === "functional"
          ? true
          : Boolean(state[category] ?? state.necessary);
      window.wp_set_consent(category, allowed ? "allow" : "deny");
    },
  );
  if (state.necessary) {
    window.wp_set_consent("functional", "allow");
  }
};

const apply = (state) => {
  writeCookie(state);
  setWpConsent(state);
  document.body.classList.toggle(
    "nanzora-consent-marketing",
    Boolean(state.marketing),
  );
  document.body.classList.toggle(
    "nanzora-consent-marketing-denied",
    !state.marketing,
  );
  root?.setAttribute("data-nanzora-consent-decided", "1");
  root?.setAttribute("hidden", "");
};

const show = () => {
  root?.removeAttribute("hidden");
};

if (root && !config.decided) {
  show();
}

root
  ?.querySelector("[data-nanzora-consent-accept]")
  ?.addEventListener("click", () => {
    apply({
      necessary: true,
      preferences: true,
      statistics: true,
      marketing: true,
    });
  });

root
  ?.querySelector("[data-nanzora-consent-reject]")
  ?.addEventListener("click", () => {
    apply({
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false,
    });
  });

root
  ?.querySelector("[data-nanzora-consent-manage]")
  ?.addEventListener("click", (event) => {
    const expanded = prefs && !prefs.hidden;
    if (prefs) prefs.hidden = expanded;
    event.currentTarget.setAttribute(
      "aria-expanded",
      expanded ? "false" : "true",
    );
  });

prefs?.addEventListener("submit", (event) => {
  event.preventDefault();
  const state = {
    necessary: true,
    preferences: Boolean(prefs.querySelector('[name="preferences"]')?.checked),
    statistics: Boolean(prefs.querySelector('[name="statistics"]')?.checked),
    marketing: Boolean(prefs.querySelector('[name="marketing"]')?.checked),
  };
  apply(state);
});

document
  .querySelectorAll("[data-nanzora-cookie-settings]")
  .forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      show();
      if (prefs) prefs.hidden = false;
    });
  });
